<script setup>
import Grid from "../../../../../frontend/src/components/Grid.vue";
import useGrid from "@/composables/useGrid";
import {onMounted, ref} from "vue";
import aiSequencesService from "@/services/ai-sequences.service";
import aiPromptsService from "@/services/ai-prompts.service";
import {useRoute} from "vue2-helpers/vue-router";

const route = useRoute();
const {items, gridParams, gridMethods} = useGrid(aiSequencesService.getLogs);
const showPromptText = ref(false);
const promptText = ref('');

const columns = [
    {
        label: 'Startup ID',
        name: 'startup_id',
        filter: 'text',
        component: 'Link',
    },
    {
        label: 'Startup Name',
        name: 'startup_name',
        filter: 'text',
    },
    {
        label: 'Startup URL',
        name: 'startup_website',
        filter: 'text',
        component: 'Link',
    },
    {
        label: 'Field Name',
        name: 'field_name',
        filter: 'single-select',
        options: [
            {
                id: 'gemini_trl_score',
                name: 'TRL Score'
            },
            {
                id: 'gemini_tam',
                name: 'TAM'
            },
            {
                id: 'gemini_founders_history',
                name: 'Founders History'
            },
            {
                id: 'gemini_patents',
                name: 'Patents'
            },
            {
                id: 'gemini_geographical_presence',
                name: 'Geographical Presence'
            },
        ]
    },
    {
        label: 'Value',
        name: 'value',
    },
    {
        label: 'Service',
        name: 'service',
        filter: 'single-select',
        options: [
            {
                id: 'gpt',
                name: 'GPT'
            },
            {
                id: 'gemini',
                name: 'Gemini'
            },
            {
                id: 'ppx',
                name: 'Perplexity'
            },
            {
                id: 'claude',
                name: 'Claude'
            },
        ]
    },
    {
        label: 'Model',
        name: 'model',
    },
    {
        label: 'Prompt',
        name: 'version',
        component: 'Link',
    },
];

onMounted(() => {
    gridMethods.setColumns(columns);

    if (route.query.startup_id) {
        gridMethods.setFilters({
            startup_id: route.query.startup_id,
        });
    } else {
        gridMethods.resetList();
    }
});

async function showPrompt(id) {
    const {data} = await aiPromptsService.getVersionText(id);

    promptText.value = data;
    showPromptText.value = true;
}

function gridAction(params) {
    if (params.action === 'view') {
        showPrompt(params.params.prompt_version_id);
    }
}

</script>

<template>
    <div>
        <div class="main-table-wrapper">
            <div class="main-table overflow-auto">
                <Grid
                    :columns="columns"
                    :data="items"
                    has-filters
                    :page-length="parseInt(gridParams.pageLength)"
                    :total-rows-count="gridParams.totalRowsCount"
                    :sort="gridParams.sort"
                    :currentPage="gridParams.currentPage"
                    @changePage="gridMethods.changePage"
                    @changeFilters="gridMethods.setFilters"
                    @changeSort="gridMethods.changeSort"
                    @action="gridAction"
                />
            </div>
        </div>

        <b-modal v-model="showPromptText" title="Prompt Text" modal-class="modal-w-xxl" hide-footer>
            <pre>
                {{promptText}}
            </pre>
        </b-modal>
    </div>
</template>

<style scoped>

</style>
